import React from 'react';
import { Info } from 'lucide-react';

/**
 * Modo de execução da conta.
 *
 * O aviso sobre a fase atual não é decorativo: ligar `private_edge` hoje prepara
 * a conta, mas mensagens e MCPs continuam saindo pelo Core. Sem isso, alguém
 * ligaria o modo esperando que o tráfego passasse a ir pelo Edge.
 */
function ExecutionModeCard({ executionMode, onChange, saving, canManage }) {
  const isPrivateEdge = executionMode === 'private_edge';

  return (
    <div className="surface-card p-4 space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div>
          <p className="font-medium text-content-primary">Modo de execução da conta</p>
          <p className="text-sm text-content-muted mt-1">
            {isPrivateEdge
              ? 'Canais e MCPs desta conta pertencem a um Edge Connector na infraestrutura do cliente.'
              : 'O Core fala direto com provedores de canal e MCPs públicos.'}
          </p>
        </div>
        <button
          type="button"
          onClick={() => onChange(isPrivateEdge ? 'standard' : 'private_edge')}
          disabled={saving || !canManage}
          className="btn-secondary text-sm px-4 py-2.5 shrink-0 disabled:opacity-50"
        >
          {saving
            ? 'Salvando...'
            : isPrivateEdge
              ? 'Voltar para padrão'
              : 'Ativar private_edge'}
        </button>
      </div>

      <div className="flex items-start gap-2 rounded-lg bg-slate-50 border border-slate-200 px-3 py-2">
        <Info className="h-4 w-4 text-slate-500 shrink-0 mt-0.5" aria-hidden />
        <p className="text-xs text-content-muted">
          Nesta fase o modo apenas prepara a conta: identidade e heartbeat do connector
          já funcionam, mas configuração de recursos, mensagens e chamadas MCP continuam
          seguindo pelo Core.
        </p>
      </div>
    </div>
  );
}

export default ExecutionModeCard;
